import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { reportData } from '../data/reportData';
import SEO from '../components/SEO';
import { FiArrowLeft, FiBarChart2 } from 'react-icons/fi';
import CTABlock from '../components/CTABlock';

export default function Section() {
  const { slug } = useParams();
  
  const section = reportData.sections.find(s => s.slug === slug);
  
  if (!section) return <Navigate to="/shadow-ai-benchmark-report-2026" />;

  const questions = section.questions.map(qId => ({
    id: qId,
    ...reportData.questions[qId]
  }));

  return (
    <div className="bg-slate-50 min-h-screen pb-20">
      <SEO title={`${section.title} Data | Shadow AI Report`} description={section.description} />
      
      {/* Header */}
      <div className="bg-white border-b border-slate-200 pt-12 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <Link to="/shadow-ai-benchmark-report-2026" className="inline-flex items-center gap-2 text-sm font-medium text-slate-500 hover:text-slate-900 mb-8 transition-colors">
            <FiArrowLeft /> Back to Report Overview
          </Link>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">{section.title}</h1>
          <p className="text-xl text-slate-600 leading-relaxed">{section.description}</p>
        </div>
      </div>

      {/* Questions List */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h2 className="text-sm font-bold tracking-widest text-slate-400 uppercase mb-8">Data Points in this Section</h2>
        <div className="space-y-4">
          {questions.map((q, idx) => (
            <Link key={q.id} to={`/${q.id}`} className="block group">
              <div className="bg-white border border-slate-200 rounded-xl p-6 md:p-8 hover:border-slate-400 hover:shadow-md transition-all flex flex-col md:flex-row gap-6 md:items-center justify-between">
                <div className="flex-grow">
                  <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-peridot-700 transition-colors">
                    {q.title}
                  </h3>
                  <p className="text-slate-600 text-sm line-clamp-2">{q.hook}</p>
                </div>
                <div className="shrink-0">
                  <span className="inline-flex items-center gap-2 text-sm font-semibold text-peridot-600 bg-peridot-50 px-4 py-2 rounded-lg group-hover:bg-peridot-100 transition-colors">
                    <FiBarChart2 /> View Data
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4">
         <CTABlock />
      </div>
    </div>
  );
}